"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BaseViewStore = function BaseViewStore(props, Component) {
  (0, _classCallCheck3.default)(this, BaseViewStore);

  this.props = props;
  this.constructor.setUpMock && this.constructor.setUpMock(this);
};

exports.default = BaseViewStore;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(BaseViewStore, "BaseViewStore", "src/core_modules/base-viewstore/index.js");
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/platform-client-bootstrap/dist/core_modules/base-viewstore/index.js
// module id = ./node_modules/platform-client-bootstrap/dist/core_modules/base-viewstore/index.js
// module chunks = 0